import { Component, OnInit, ChangeDetectionStrategy, Input, NgZone, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { IWorkflow, Workflow } from '@ispm/core/interfaces/workflow.interface';
import { CoreActionCreatorService } from '@ispm/core/services/core-action-creator.service';
import { WorkflowConfigService } from '@ispm/workflow/services/workflow-config.service';
import { Subject } from 'rxjs/Subject';
import { TherapiesActionCreatorService } from '@ispm/therapies/services/therapies-action-creator.service';
import { Observable } from 'rxjs/Observable';
import { filter, map, tap } from 'rxjs/operators';
import { ItherapyMatch } from '@ispm/therapies/interfaces/therapy-match.interface';
import { UserActionCreatorService } from '@ispm/user/services/user-action-creator.service';
import { take } from 'rxjs/operators';
import * as immutable from 'immutable';
import { UserService } from '@ispm/user/services/user.service';
import { TestService } from '@ispm/dashboard/test/services/test.service';
import { WorkflowService } from '@ispm/workflow/services/workflow.service';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import { activeTabObject } from "@ispm/test/constants/Tabs.constants";
import { RouterManagerService } from '@ispm/core/services/router-manager.service';
import { PollJobService } from '@ispm/test/services/poll-job.service';

@Component({
  selector: 'gen-manual-curation-confirmation',
  templateUrl: './manual-curation-confirmation.component.html',
  styleUrls: ['./manual-curation-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManualCurationConfirmationComponent implements OnInit, OnDestroy, OnChanges {
  _organization: { permissions };
  store: any;

  private revisionId: string;
  private workflowId: string;
  private destroyer$: Subject<null> = new Subject<null>();
  public inputButtonArgs: any;
  public inputButtonCssArgs: any;
  public totalUncurated$: Observable<number>;
  public isWaitingForManualCurationAvailable: boolean = false;
  public opinion$: Observable<any>;
  private opinion: any;
  public selectedAberrationKeys = [];
  public IsMDA;
  private patient;
  @Input() isPerformer: boolean = false;

  @Input()
  public changeOpinionOfMIIn: boolean;


  constructor(private routerManagerService: RouterManagerService,
              private _ngZone: NgZone,
              private coreAC: CoreActionCreatorService,
              private _therapiesAC: TherapiesActionCreatorService,
              private _userService: UserService,
              private userAC: UserActionCreatorService,
              private workflowConfigService: WorkflowConfigService,
              private authService: AuthenticationService,
              private workflowService: WorkflowService,
              public testService: TestService,
              private notificationMessageService: NotificationMessageService,
              private pollJobService: PollJobService,
  ) {

    this.revisionId = this.routerManagerService.parameters.revisionId;
    this.workflowId = this.routerManagerService.parameters.testId;
    this.totalUncurated$ = this._therapiesAC.getState('uncharacterizedTherapies')
      .pipe(
        map((therapies: Array<ItherapyMatch>) => therapies && therapies.length)
      );
    this._therapiesAC.getOpinion().pipe(take(1)).subscribe();
  }

  ngOnInit() {
    this.userAC.getStore().select('organizationConfiguration')
      .pipe(
        take(1)
      ).subscribe(organization => {
      this._organization = organization;
    });

    const workflowRequest = this.workflowService.currentTest.workflowRequest;
    this.IsMDA = this.workflowService.isMDA();

    if (this.IsMDA) {
      this.setOpinionSubscriber();
    }

    this.workflowConfigService.getActiveWorkflow()
      .takeUntil(this.destroyer$.asObservable())
      .filter(workflow => !!workflow && !!this.testService.testConfiguration)
      .subscribe(currentWorkflow => {
        const revision = Workflow.getRevision(currentWorkflow.revisions, this.revisionId);
        const currentStep = Workflow.getCurrentStep(revision, (<IWorkflow>currentWorkflow).activeJob);

        // Checks the Waitingformanualcurationavailable property against the "TestConfiguration" table StepType
        this.isWaitingForManualCurationAvailable = currentStep &&
          this.testService.testConfiguration.hasOwnProperty(currentStep.type) &&
          this.testService.testConfiguration[currentStep.type].hasOwnProperty('waitingForManualCurationAvailable') &&
          this.testService.testConfiguration[currentStep.type].waitingForManualCurationAvailable;

        if (currentStep && this.testService.testConfiguration.hasOwnProperty(currentStep.type) &&
          this.testService.testConfiguration[currentStep.type].hasOwnProperty('inputButtons')) {

          this.inputButtonArgs = this.testService.testConfiguration[currentStep.type].inputButtons.filter((input) => {
            return input.type === 'userInputButton';
          });
        }
      });

    this.userAC.getStore().select('currentPatient')
      .pipe(
        take(1)
      ).subscribe(patient => {
      this.patient = patient;
    });
  }

  ngOnDestroy(): void {
    this.destroyer$.next();
    this.destroyer$.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName == 'changeOpinionOfMIIn' && changes[propName].currentValue != changes[propName].previousValue && this.IsMDA) {
        this.getSelectedAberrations();
      }
    }
  }

  public isUserCanPressManualCurationButton(inputButtonKeyParam) {
    if (!this._organization) {
      return;
    }

    const curationEnabled = this._organization.permissions ? this._organization.permissions['AllowSendToCurationUserList'] : undefined;
    if (curationEnabled && curationEnabled.length > 0 && inputButtonKeyParam == 'ManualCuration') {
      return !(curationEnabled && curationEnabled.indexOf(this.authService.user.info.id) > -1 && this.isPerformer);
    }
    return !this.isPerformer;
  }

  public isUserCanPressManualinterpretationButton(inputButtonKeyParam) {
    if (!this.testService) {
      return;
    }

    const curationEnabled = this.testService.testConfiguration ? this.testService.testConfiguration['AllowSendToCurationUserList'] : undefined;
    if (curationEnabled && curationEnabled.length > 0 && inputButtonKeyParam == 'ManualCuration') {
      return !(curationEnabled && curationEnabled.indexOf(this.authService.user.info.id) > -1 && this.isPerformer);
    }
    return !this.isPerformer;
  }


  private setOpinionSubscriber() {
    this.opinion$ = this._therapiesAC.getState('opinion').pipe(
      filter((value: immutable.Map<string, any>) => !!value),
      tap(() => this.coreAC.setLoader(false)),
    );
    this.getSelectedAberrations();
  }

  private getSelectedAberrations() {
    this.opinion$
      .pipe(take(1))
      .subscribe(data => {
        this.opinion = data[0].includeInMI;

        if (this.opinion) {
          this.selectedAberrationKeys = [];
          Object.entries(this.opinion).map((e) => ( { [e[0]]: e[1] } ))
            .filter(element => Object.values(element)[0]['visible'] == true)
            .forEach(e => this.selectedAberrationKeys.push(Object.keys(e)));
        }
      });
  }

  private patientUUIDToUniqueInt() {
    let hash = 0;
    for (let i = 0; i < this.patient.id.length; i++) {
      const code = this.patient.id.charCodeAt(i);
      hash = ((hash << 5) - hash) + code;
      hash = hash & hash; // Convert to 32bit integer
      hash = hash & 0xfffffff;
    }
    return hash;
  }

  public performWorkflowStep(inputButtonArgsParam) {
    // analysis - diagnosticorder
    const analysis = this.testService.patientTests.current;
    // step, index
    const step = 'UiManualAberrationCuration';
    const IsMI = inputButtonArgsParam && inputButtonArgsParam.indexOf('result') > -1 && inputButtonArgsParam.split('=')[1] == '2';

    this.coreAC.setLoader(true);
    this.workflowService.performWorkflowStep(
      analysis, step, null, this.revisionId, this.workflowId, null, inputButtonArgsParam
    )
    .then(() => this.workflowConfigService.getCurrentActiveWorkflow().toPromise())
    .then((activeWorkflow: IWorkflow) => this.pollJobService.waitForWorkflowCondition(
      this.workflowId, this.revisionId,
      workflow => workflow.activeJobName !== activeWorkflow.activeJobName, 2000, 20)
    )
    .then(workflow => {
      if (workflow.activeJobName.toLowerCase().includes('fail')) {
        throw new Error('Can\'t perform workflow step');
      }
      this.notificationMessageService.success('Successfully moved to the next step');
      const xhtmlReportTemplates = this.testService.testConfiguration.xHtmlReportTemplates;
      if (xhtmlReportTemplates) {
        if (IsMI && this.IsMDA) {
          this.testService.activeTab = activeTabObject.THERAPY_PRIORITIZE;
        } else {
          this.testService.activeTab = activeTabObject.REPORT_PREVIEW;
        }
      }
      return this.routerManagerService.reload();
    })
    .catch(error => {
      console.error(error);
      this.notificationMessageService.error('Unable to move to the next step');
    })
    .finally(() => this.coreAC.setLoader(false));

    // why MI should be sent in parallel with perform workflow step?
    if (IsMI && this.IsMDA) {
      let resources = [];
      this.getSelectedAberrations();
      this.coreAC.setLoader(true);
      let MolecularFindingId;
      let AberrationId = [];
      const AberrationIdObject = [];
      let selectedAberrationKeysIds = [];
      this.selectedAberrationKeys.map(e => selectedAberrationKeysIds.push(e[0].split('|')));
      // @ts-ignore
      selectedAberrationKeysIds = selectedAberrationKeysIds.flat();
      selectedAberrationKeysIds.map(element => element.includes('TMB') || element.includes('MSI') ? MolecularFindingId=element : AberrationId.push(element));

      if (MolecularFindingId) {
        MolecularFindingId = MolecularFindingId.split('_')[0];
      }

      if (AberrationId) {
        const uniqueSet = new Set(AberrationId);
        AberrationId = [...uniqueSet];
        AberrationId.map((element, index) => AberrationIdObject.push({ 'id': element, 'idx': index}));
      }

      resources =  [
        {
          'combinedIds': [{ 'id': analysis.id, 'idx': 0}],
          'queryParam': '_id',
          'resourceType': 'DiagnosticOrder',
          'resourceIdentifier': 'diagnosticorder_id'
        }
      ];

      if (AberrationIdObject.length !== 0) {
        resources.push(
          {
            'combinedIds': AberrationIdObject,
            'queryParam': '_id',
            'resourceType': 'aberrations',
            'resourceIdentifier': 'aberration_id'
          }
        );
      }

      if (MolecularFindingId) {
        resources.push({
          'combinedIds': [{ 'id': MolecularFindingId, 'idx': 0}],
          'queryParam': '_id',
          'resourceType': 'MolecularFinding',
          'resourceIdentifier': 'MolecularFinding_id'
        });
      }

      const testId = (this.testService.testConfiguration['extends'])
        ? this.testService.testConfiguration['extends']
        : this.testService.testConfiguration['id']
      ;

      const patientName = this.patientUUIDToUniqueInt();

      if (this.testService.testConfiguration['id']) {
        this.testService.getTestConfiguration(testId).then(() => {
          this.workflowService.exportFileToExcelForMI(
            this.testService.testConfiguration.xHtmlReportTemplates[0],
            this.testService.testConfiguration.taskDispatchTemplates[0]?.reference,
            resources,
            this.revisionId,
            this.testService.testConfiguration.id,
            patientName
          )
            .subscribe(
              () => {
                this._ngZone.runOutsideAngular(() => {
                  this.notificationMessageService.success('Successfully send to MI');
                    this.coreAC.setLoader(false);
                  return this.routerManagerService.reload();
                });
              },
              () => {
                this.coreAC.setLoader(false);
                this.notificationMessageService.error('Unable to send to MI');
              }
            );
        });
      }
    }
  }
}





